// extracted by mini-css-extract-plugin
module.exports = {"root":"TabNav_root__1mTBs","tab":"TabNav_tab__3akQd","link":"TabNav_link__2_u5H","selectedLink":"TabNav_selectedLink__MGk4z","disabled":"TabNav_disabled__3MzhE"};